angular.
module("dx.webapp.onlineResources", [
	// TODO: Add deps.

	"dx.ui.utils",
]);
